var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoundation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Foundation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.4742 12.4893c0 2.2033-1.7861 3.9894-3.9893 3.9894-2.2033 0-3.9894-1.7861-3.9894-3.9894 0-2.2032 1.7861-3.9893 3.9894-3.9893 2.2032 0 3.9893 1.7861 3.9893 3.9893ZM4.84 8.88c.0731-.1267.2559-.1267.329 0l4.0718 7.0526c.0732.1266-.0183.2849-.1645.2849H.9327c-.1463 0-.2377-.1583-.1645-.2849L4.84 8.88Zm12.5362-.1426a.38.38 0 0 0-.3799.38v6.7438a.38.38 0 0 0 .3799.38h6.7439a.38.38 0 0 0 .3799-.38V9.1174a.38.38 0 0 0-.3799-.38h-6.7439Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundation);
export default __webpack_public_path__ + "static/media/foundation.ac2af668c05e6d3a659de86d1e6e8933.svg";
export { ForwardRef as ReactComponent };